import { useEffect, useState } from "react";
import { Controller, SubmitHandler, useForm } from "react-hook-form";
import { NumericFormat } from "react-number-format";
import * as S from "./styled";
//Hooks
import useLoading from '../../../../hooks/useLoading';
import apiRequest from "../../../../hooks/apiRequest";
//Components
import LayoutModal from "../../../LayoutModal";
import AddiotionInputs from "../AdditionInputs";
//Inteface
import { Inputs } from "Interfaces/IPromotion";
import { IFormPayment } from "Interfaces/IFormPayment";
import { useNavigate } from "react-router-dom";

interface ICreate {
  isOpenModalAcessory: boolean;
  setModalClose: () => void;

  idProducts: number[];
  type_product: string;
  urlProduct: {};
}

export default function CreatePromotion({
  isOpenModalAcessory,
  setModalClose,

  idProducts,
  type_product,
  urlProduct
}: ICreate) {

  const {
    register,
    control,
    reset,
    setValue,
    getValues,
    resetField,
    handleSubmit: handleFormSubmit,
    formState: { errors },
  } = useForm<Inputs>();

  let navigate = useNavigate();

  const { isLoading, startLoading, stopLoading } = useLoading();
  const [formPayment, setFormPayment] = useState<IFormPayment[]>([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await apiRequest<IFormPayment[]>("form-payment");
        const responseData = response.data;

        const filteredPayments = responseData
          .filter((payment) => payment.form_payment !== 'Cartão de Crédito')
          .map((payment) => ({
            ...payment,
            form_payment: payment.form_payment.replace('Cartão de Débito', 'Débito')
          }));

        setFormPayment(filteredPayments);
      } catch (error) {
        console.error("Erro ao obter dados:", error);
      }
    };
    fetchData();
  }, []);

  const onSubmit: SubmitHandler<Inputs> = async (data) => {
    startLoading();
    try {

      const promotion_items = idProducts?.map((val) => {
        return {
          type: type_product,
          id: val
        }
      })

      const filtersUrl = Object.entries(urlProduct)
        .filter(([_, value]) => value !== "") //remover os filtros vazios
        .map(([key, value]) => ({
          type: key,
          name: String(value)
        }));

      const payload = {
        ...data,
        filters: filtersUrl,
        promotionItems: promotion_items || [],
      }
      console.log('payload: ', payload);

      const response = await apiRequest<Inputs>('promotion', 'POST', payload);
      if (response.status === 201) {
        alert("Promoção criada com sucesso!");
        onClose();
        reset();
      }
    } catch (error: any) {
      alert(error.message || "Ocorreu um erro ao criar a promoção.");
    } finally {
      stopLoading();
    }
  };

  const onClose = () => {
    setModalClose();
  }

  if (isOpenModalAcessory) {
    return (
      <LayoutModal
        statusLoad={isLoading}
        title="Registrar Promoção"
        subTitle="Preencha os dados da promoção do produto."
        setModalClose={onClose}
        submiteModal={handleFormSubmit(onSubmit)}>
        <S.Container>
          <S.FormInput>
            <S.Label>
              Nível de Autorização
              <span>*</span>
            </S.Label>
            <S.Select
              {...register("auth", { required: true })}>
              <option value="" disabled selected hidden>
                Selecione
              </option>
              <option value="Administrador">
                Administrador
              </option>
              <option value="Gerente">
                Gerente
              </option>
              <option value="Loja">
                Loja
              </option>
            </S.Select>
            {errors.auth && (
              <S.InforErro>Campo Obrigatório</S.InforErro>
            )}
          </S.FormInput>

          <S.FormInput>
            <S.Label>
              Nome da Promoção
              <span>*</span>
            </S.Label>
            <S.Input
              placeholder="Informe o nome da Promoção"
              type="text"
              {...register("title", { required: true })}
            />
            {errors.title && (
              <S.InforErro>Campo Obrigatório</S.InforErro>
            )}
          </S.FormInput>


          <S.FeaturedSection>
            <S.Title>
              Desconto À vista (%)
              <span>*</span>
            </S.Title>
            {formPayment.map((val, index) => (
              <S.FormInput key={val.id}>
                <S.ContentInput >
                  <S.LabelGray>{val.form_payment || '-'}</S.LabelGray>
                  <Controller
                    name={`cashPromotions.${index}.discount`}
                    rules={{ required: "Campo Obrigatório" }}
                    control={control}
                    render={({ field: { onChange, value, ref } }) => (
                      <NumericFormat
                        thousandSeparator="."
                        decimalSeparator=","
                        decimalScale={2}
                        fixedDecimalScale={true}
                        placeholder="0,00 %"
                        suffix=" %"
                        value={value}
                        onValueChange={(values) => {
                          const discountValue = values.floatValue ?? 0;
                          setValue(`cashPromotions.${index}.form_payment_id`, val.id);
                          onChange(discountValue);
                        }}
                        getInputRef={ref}
                      />
                    )}
                  />

                </S.ContentInput>
                {errors.cashPromotions?.[index]?.discount && (
                  <S.InforErro>Campo Obrigatório</S.InforErro>
                )}
              </S.FormInput>

            ))}
          </S.FeaturedSection>

          <AddiotionInputs
            getValues={getValues}
            register={register}
            errors={errors}
            reset={reset}
            control={control}
            setValue={setValue}
            resetField={resetField} />

          <S.FormInput>
            <S.Label>
              Desconto no Crediário
              <span>*</span>
            </S.Label>
            <Controller
              name={'store_credit_discount'}
              rules={{ required: "Campo Obrigatório" }}
              control={control}
              render={({ field: { onChange, value, ref } }) => (
                <NumericFormat
                  thousandSeparator="."
                  decimalSeparator=","
                  decimalScale={2}
                  fixedDecimalScale={true}
                  placeholder="0,00 %"
                  suffix=" %"
                  value={value}
                  onValueChange={(values) => {
                    const discountValue = values.floatValue ?? 0;
                    onChange(discountValue);
                  }}
                  getInputRef={ref}
                />
              )}
            />
            {errors.store_credit_discount && (
              <S.InforErro>Campo Obrigatório</S.InforErro>
            )}
          </S.FormInput>

          <S.SeparateDiv>
            <S.FormInput>
              <S.Label>
                Período Inicial
                <span>*</span>
              </S.Label>
              <S.Input
                placeholder="Informe o nome da Promoção"
                type="date"
                {...register("start", { required: true })}
              />
              {errors.start && (
                <S.InforErro>Campo Obrigatório</S.InforErro>
              )}
            </S.FormInput>

            <S.FormInput>
              <S.Label>
                Período Final
                <span>*</span>
              </S.Label>
              <S.Input
                placeholder="Informe o nome da Promoção"
                type="date"
                {...register("end", { required: true })}
              />
              {errors.end && (
                <S.InforErro>Campo Obrigatório</S.InforErro>
              )}
            </S.FormInput>
          </S.SeparateDiv>
        </S.Container>
      </LayoutModal>
    );
  }
  return null;
}
